import { TagContextProvider, TagRefreshButton } from '@abtasty/tag-refresh-button';
import { memo } from 'react';
import { de, enUS, es, fr } from 'date-fns/locale';

import { useSegmentTrack } from '@application/hooks/useSegment/useSegment';
import { useAccountId } from '@src/application/modules/tag/hooks/hooks';

import { useTagData } from '../../shared/tag/context/useTagData';
import { useUserContext } from '../../shared/tag/context/UserContext/useUserContext';
import { PackType, Timezone } from '@abtasty/api-client';

export const localeByLanguage = {
  en_US: enUS,
  de,
  es,
  fr,
};

export const TagRefresh = memo(() => {
  const accountId = useAccountId();
  const { profile } = useUserContext();
  const sendTracking = useSegmentTrack();
  const tagData = useTagData();

  const { pack, frameworkVersion } = tagData?.accountData?.accountSettings;
  const language = profile?.value?.lang || 'en_US';
  const locale = localeByLanguage[language];
  const timezone = Intl.DateTimeFormat().resolvedOptions().timeZone as Timezone;
  const tagFrameworkPage = `${process.env.APP_URL}/settings/framework#errors`;

  const onEvent = (eventName: string) => {
    switch (eventName) {
      case 'compile-tag-clicked':
        sendTracking('CS-ck- Tag refresh qaa');
        break;

      default:
        break;
    }
  };

  return (
    <TagContextProvider
      settingsUrl={tagFrameworkPage}
      accountId={accountId!}
      hasPrivilege
      tagVersion={frameworkVersion}
      pack={pack as PackType}
      language={language}
      locale={locale}
      timezone={timezone}
      apiHostname={process.env.API_HOST_DEFAULT}
      onEvent={onEvent}
    >
      <TagRefreshButton />
    </TagContextProvider>
  );
});
